module.exports = __webpack_public_path__ + "img/3.33cab86e.svg";